import { render, staticRenderFns } from "./ShortHandsMenu.vue?vue&type=template&id=362781ec"
import script from "./ShortHandsMenu.vue?vue&type=script&lang=js"
export * from "./ShortHandsMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports